// Mundo - Maximum Dosage: heals 50% of max HP over 3 ticks. No damage.

import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityContext, AbilityHit } from "./Ability";

const TICK_COUNT        = 3;
const TICK_INTERVAL_MS  = 1000;
const TOTAL_HEAL_PCT    = 0.50;

export const mundoUlt: Ability = {
  id: "mundoUlt",
  displayName: "Maximum Dosage",
  description: "Heals 50% of max HP over 3 seconds.",
  iconId: "DrMundo_R",

  targetShape({ caster }: AbilityContext) {
    return [caster.pos];
  },

  computeHits({ caster }: AbilityContext): AbilityHit[] {
    const stats       = effectiveStats(caster);
    const healPerTick = Math.round(stats.maxHp * TOTAL_HEAL_PCT / TICK_COUNT);

    return Array.from({ length: TICK_COUNT }, (_, i) => ({
      target:  caster,
      amount:  0,
      type:    "none" as const,
      heal:    healPerTick,
      delayMs: i * TICK_INTERVAL_MS,
    }));
  },
};
